module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', [(_vm.isPageReady) ? _c('v-container', {
    staticClass: "content-section genre",
    attrs: {
      "grid-list-lg": "",
      "pa-0": ""
    }
  }, [(_vm.show_selector_view) ? _c('v-layout', {
    staticClass: "pgs_area",
    attrs: {
      "row": "",
      "wrap": "",
      "ma-0": ""
    }
  }, [_vm._l((_vm.genres), function(parent, index) {
    return _c('div', {
      staticClass: "pgs-wrapper"
    }, [_c('div', {
      key: parent.id,
      staticClass: "pgs"
    }, [_c('div', {
      staticClass: "pgs-inner-wrapper",
      class: ("bg-color-" + index),
      on: {
        "click": function($event) {
          _vm.checkParentGenre(parent, !parent.value)
        }
      }
    }, [_c('div', {
      staticClass: "pgs-inner"
    }, [_c('div', {
      staticClass: "pgs__title"
    }, [_c('label', [_vm._v(_vm._s(parent.name))])]), _vm._v(" "), _c('div', {
      staticClass: "pgs__description"
    }, [_c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectParent(parent, index)
        }
      }
    }, [_vm._v("+" + _vm._s(_vm.getSelectedChildrenCount(parent)) + " Subgenres")])]), _vm._v(" "), _c('div', {
      staticClass: "pgs__content"
    }, [_c('div', {
      staticClass: "upload-info"
    }, [_c('label', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(parent.users_size)))]), _vm._v(" "), _c('span', [_vm._v("Album Uploaded")])]), _vm._v(" "), (parent.value) ? _c('div', {
      staticClass: "pgs__badge check-o"
    }) : _c('div', {
      staticClass: "pgs__badge check"
    })])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "actions-wrapper"
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveGenreFilters()
      }
    }
  }, [_vm._v("Save")])], 1)], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.show_selector_view) ? _c('div', {
    staticClass: "content-section genre"
  }, [_c('div', {
    staticClass: "genre-container"
  }, [_c('div', {
    staticClass: "genre__header"
  }, [_c('div', {
    staticClass: "pgs-wrapper"
  }, [_c('div', {
    key: _vm.parent.id,
    staticClass: "pgs"
  }, [_c('div', {
    staticClass: "pgs-inner-wrapper",
    class: ("bg-color-" + _vm.parent_index)
  }, [_c('div', {
    staticClass: "pgs-inner"
  }, [_c('div', {
    staticClass: "pgs__title"
  }, [_vm._v(_vm._s(_vm.parent.name))]), _vm._v(" "), _c('div', {
    staticClass: "pgs__description"
  }, [_vm._v("\n                    +" + _vm._s(_vm.getSelectedChildrenCount(_vm.parent)) + " Subgenres\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "pgs__content"
  }, [(_vm.parent.value) ? _c('div', {
    staticClass: "pgs__badge check-o"
  }) : _c('div', {
    staticClass: "pgs__badge check"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "genre__content"
  }, [_c('v-layout', {
    key: _vm.parent.id,
    attrs: {
      "row": "",
      "wrap": "",
      "ma-0": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('p', {
    staticClass: "regular-checkbox settings parent-genre"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parent.value),
      expression: "parent.value"
    }],
    attrs: {
      "id": _vm.parent.id,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.parent.value) ? _vm._i(_vm.parent.value, null) > -1 : (_vm.parent.value)
    },
    on: {
      "click": function($event) {
        _vm.checkParentGenre(_vm.parent)
      },
      "change": function($event) {
        var $$a = _vm.parent.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.parent.value = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.parent.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.parent, "value", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.parent.id
    }
  }, [_vm._v("Select All")])])]), _vm._v(" "), _vm._l((_vm.parent.children), function(child) {
    return _c('v-flex', {
      key: child.id,
      attrs: {
        "xs12": "",
        "sm3": ""
      }
    }, [_c('p', {
      staticClass: "regular-checkbox settings"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (child.value),
        expression: "child.value"
      }],
      attrs: {
        "id": child.id,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(child.value) ? _vm._i(child.value, null) > -1 : (child.value)
      },
      on: {
        "click": function($event) {
          _vm.checkChildGenre(_vm.parent, child)
        },
        "change": function($event) {
          var $$a = child.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (child.value = $$a.concat([$$v]))
            } else {
              $$i > -1 && (child.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(child, "value", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": child.id
      }
    }, [_vm._v(_vm._s(child.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(child.users_size) + ")")])])])
  })], 2)], 1)]), _vm._v(" "), _c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_selector_view = true
      }
    }
  }, [_vm._v("OK")])], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_load_genre_confirm_dialog),
      callback: function($$v) {
        _vm.show_load_genre_confirm_dialog = $$v
      },
      expression: "show_load_genre_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Save current genre setting?")]), _vm._v(" "), _c('div', [_vm._v("You can save current genre setting and load it later")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "pt-3": ""
    }
  }, [_c('v-flex', {
    staticClass: "d-flex",
    attrs: {
      "xs2": ""
    }
  }, [_c('label', {
    staticClass: "text-xs-left"
  }, [_vm._v("Name")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "d-flex",
    attrs: {
      "xs10": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preset_name),
      expression: "preset_name"
    }],
    staticClass: "py-1 px-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.preset_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preset_name = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        _vm.savePreset()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeLoadGenreConfirmDialog()
      }
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    directives: [{
      name: "on-click-outside",
      rawName: "v-on-click-outside",
      value: (_vm.closeLoadGenreDialog),
      expression: "closeLoadGenreDialog"
    }],
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_load_genre_dialog),
      callback: function($$v) {
        _vm.show_load_genre_dialog = $$v
      },
      expression: "show_load_genre_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Load Genre")]), _vm._v(" "), _c('v-list', [_vm._l((_vm.presets), function(preset, index) {
    return [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(preset.name))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('div', [_c('v-btn', {
      staticClass: "mr-2",
      attrs: {
        "icon": "",
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.removePreset(preset.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("fa-trash")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.loadPreset(preset.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("fa-download")])], 1)], 1)])], 1), _vm._v(" "), (index + 1 < _vm.presets.length) ? _c('v-divider', {
      key: preset.id
    }) : _vm._e()]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeLoadGenreDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description-section genre"
  }, [_c('label', [_vm._v("Tailor your experience by removing music genres you don't like.")]), _vm._v(" "), _c('label', [_vm._v("You will no longer see the selected genres unless you visit a specific\n      profile, or unhide the genre.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32a9331e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/components/genre_tab.vue
// module id = 1673
// module chunks = 180